import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { trimDecimals } from 'shared/../constants/Formatting';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const PercentInput = ({ value, disabled, onChange, onBlur, ...inputProps }) => {
  let input = null;

  const [focused, setFocused] = useState(false);
  useEffect(() => {
    if (input) {
      input.focus();
    }
  }, [focused]);

  return (
    <React.Fragment>
      {focused && (
        <input
          {...inputProps}
          defaultValue={trimDecimals(value * 100)} // initial value needs to be 100x so user sees 16 not .16 for 16%
          value={value}
          disabled={disabled}
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          onBlur={() => {
            // parse value into number, then divide by 100 so 16 turns into .16 for server save
            // since we are dealing with percents
            const newVal = parseFloat(value);

            // validate the field to ensure its a number
            if (newVal.toString() === 'NaN') {
              onChange(0);
              if (onBlur) {
                onBlur(0);
              }
            } else if (onChange) {
              onChange(trimDecimals(newVal / 100, 4));
              if (onBlur) {
                onBlur(trimDecimals(newVal / 100, 4));
              }
            }
            setFocused(false);
          }}
          ref={i => (input = i)}
        />
      )}
      {!focused && (
        <input
          {...inputProps}
          value={`${trimDecimals(value * 100)}%`}
          onChange={() => {
            /* Do nothing */
          }}
          disabled={disabled}
          onFocus={() => {
            // on focus we need to make sure the value is multiplied by 100 so
            // user can enter 16 for 16% instead of .16
            const newVal = parseFloat(value);

            // validate the field to ensure its a number
            if (newVal.toString() === 'NaN') {
              onChange(0);
            } else if (onChange) {
              onChange(trimDecimals(newVal * 100));
            }

            setFocused(true);
          }}
        />
      )}
    </React.Fragment>
  );
};

PercentInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func
};

export default PercentInput;
